import capitalize from 'lodash/capitalize';
import compact from 'lodash/compact';
import isBoolean from 'lodash/isBoolean';

import formatPrice from '../../services/formatPrice';

/**
 * Get a human-readable string for a coverage variable
 * 1000 => $1,000
 * null => 'Not Included'
 * false => 'Not Included'
 * true => 'Included
 *
 * @param {String|Number|Boolean} val The value to format.
 * @param {String} [key] The key name.
 * @param {Object} [opts={}] The options.
 * @param {Boolean} [opts.capitalize=true] The flag that determines whether to capitalize non-number strings.
 * @return {String} The formatted string.
 */

export function getCoverageVarString(
  val?: string | boolean | null,
  key?: string | null,
  opts = { capitalize: true }
) {
  if (isBoolean(val)) {
    return val ? 'Included' : 'Not Included';
  }
  if (!val) {
    return 'Not Included';
  }
  if (/(\d+)\/?(\d+)?/.test(val as string)) {
    const nums = compact(
      val
        .toString()
        .match(/(\d+)\/?(\d+)?/)
        ?.slice(1)
    );
    const formattedNums = nums.map((el) =>
      formatPrice(el, { fractionDigits: 0 })
    );

    if (key === 'collision_deductible') {
      return `${formattedNums.join('/')} Deductible`;
    }

    return formattedNums.join('/');
  }
  return opts.capitalize ? capitalize(val as string) : val;
}
